import { Action } from '@ngrx/store';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { Place } from 'app/core/interfaces/place.interface';
import { DatesWithFlorderInfoTO } from 'app/core/store/calendar/common/calendar.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { FlorderDetail, RelocationDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';

export const CALENDAR_RELOCATIONS_LOAD = 'calendar-relocations:CALENDAR_RELOCATIONS_LOAD';
export const CALENDAR_RELOCATIONS_LOAD_FAIL = 'calendar-relocations:CALENDAR_RELOCATIONS_LOAD_FAIL';
export const CALENDAR_RELOCATIONS_LOAD_SUCCESS = 'calendar-relocations:CALENDAR_RELOCATIONS_LOAD_SUCCESS';

export const CALENDAR_RELOCATIONS_SHOW_CREATE_RELOCATION_MODAL = 'calendar-relocations:CALENDAR_RELOCATIONS_SHOW_CREATE_RELOCATION_MODAL';

export const CALENDAR_RELOCATIONS_TEMPLATE_SELECTED = 'calendar-relocations:CALENDAR_RELOCATIONS_TEMPLATE_SELECTED';

export const CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES = 'calendar-relocations:CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES';
export const CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_FAIL = 'calendar-relocations:CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_FAIL';
export const CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_SUCCESS = 'calendar-relocations:CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_SUCCESS';

export const CALENDAR_RELOCATIONS_CLEAR_STATE = 'calendar-relocations:CALENDAR_RELOCATIONS_CLEAR_STATE';

export class CalendarRelocationsLoadAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_LOAD;
  logPayload = ['filter'];

  ui = {
    id: CALENDAR_RELOCATIONS_LOAD,
    busy: true,
  };

  constructor(readonly payload: { definitions: Definitions; places: { [key: string]: Place }; filter?: FlordersFilter }) {}
}

export class CalendarRelocationsLoadSuccessAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_LOAD_SUCCESS;
  readonly module = 'relocation';

  ui = {
    id: CALENDAR_RELOCATIONS_LOAD, // is id for busy
    busy: false,
  };

  constructor(readonly payload: { dates: DatesWithFlorderInfoTO }) {}
}

export class CalendarRelocationsLoadFailAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_LOAD_FAIL;
  logPayload = true;

  ui = {
    id: CALENDAR_RELOCATIONS_LOAD,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarRelocationsTemplateSelectedAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_TEMPLATE_SELECTED;

  constructor(readonly payload: RelocationDetail) {}
}

export class CalendarRelocationsRequestRelocationUnloadingDatesAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES;

  ui = {
    id: CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES,
    busy: true,
  };
}

export class CalendarRelocationsRequestRelocationUnloadingDatesSuccessAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_SUCCESS;

  ui = {
    id: CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarRelocationsRequestRelocationUnloadingDatesFailAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES_FAIL;
  logPayload = true;

  ui = {
    id: CALENDAR_RELOCATIONS_REQUEST_RELOCATION_UNLOADING_DATES,
    busy: false,
  };

  constructor(readonly payload: any) {}
}

export class CalendarRelocationsClearStateAction implements Action {
  readonly type = CALENDAR_RELOCATIONS_CLEAR_STATE;
}

export type Actions =
  | CalendarRelocationsLoadAction
  | CalendarRelocationsLoadSuccessAction
  | CalendarRelocationsLoadFailAction
  | CalendarRelocationsTemplateSelectedAction
  | CalendarRelocationsRequestRelocationUnloadingDatesAction
  | CalendarRelocationsRequestRelocationUnloadingDatesSuccessAction
  | CalendarRelocationsRequestRelocationUnloadingDatesFailAction
  | CalendarRelocationsClearStateAction;
